import { ToastState } from "../state";
import { ToasterActions, ToasterAction } from "../actions/toaster.action";

const initialState: ToastState = {
    toasts: [],
};

const toastReducer = (state: ToastState = initialState, action: ToasterAction): ToastState => {
    switch (action.type) {
        case ToasterActions.AddToast:
            return {
                ...state,
                toasts: [...state.toasts, action.payload],
            };
        case ToasterActions.RemoveToast:
            return {
                ...state,
                toasts: state.toasts.filter(toast => toast.id !== action.id),
            };
        default:
            return state;
    }
};

export default toastReducer;